import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const AddCat = ({ onAdd }) => {
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const createEmptyForm = () => ({
    name: '',
    age: '',
    breed: '',
    color: '',
    personality: '',
    photo: ''
  });
  const [formData, setFormData] = useState(createEmptyForm);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(current => ({
        ...current,
        photo: typeof reader.result === 'string' ? reader.result : ''
      }));
    };
    reader.readAsDataURL(file);
  };

  const handlePhotoClear = () => {
    setFormData(current => ({
      ...current,
      photo: ''
    }));

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || !formData.age || !formData.breed || !formData.color) {
      alert('Please fill in all required fields');
      return;
    }

    onAdd(formData);
    setFormData(createEmptyForm());

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    navigate('/');
  };

  return (
    <div className="form-container">
      <h1>Add New Cat</h1>
      <form onSubmit={handleSubmit} className="cat-form">
        <div className="form-group">
          <label htmlFor="name">Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="age">Age (years) *</label>
          <input
            type="number"
            id="age"
            name="age"
            min="0"
            value={formData.age}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="breed">Breed *</label>
          <input
            type="text"
            id="breed"
            name="breed"
            value={formData.breed}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="color">Color *</label>
          <input
            type="text"
            id="color"
            name="color"
            value={formData.color}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="personality">Personality</label>
          <textarea
            id="personality"
            name="personality"
            value={formData.personality}
            onChange={handleInputChange}
            rows="4"
          />
        </div>

        <div className="form-group">
          <label htmlFor="photo">Upload Photo</label>
          <input
            type="file"
            id="photo"
            name="photo"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
          />
          {formData.photo && (
            <div className="photo-preview">
              <img src={formData.photo} alt={`${formData.name || 'New'} preview`} />
              <button type="button" className="btn btn-secondary" onClick={handlePhotoClear}>
                Remove Photo
              </button>
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn btn-primary">
            Add Cat
          </button>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={() => navigate('/')}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddCat;
